import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPrevious = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.75 5.455c0-.452.321-.705.583-.705h1.334c.262 0 .583.253.583.705v13.09c0 .452-.321.705-.583.705H4.333c-.262 0-.583-.253-.583-.704zm.583-2.205c-1.21 0-2.083 1.05-2.083 2.205v13.09c0 1.155.873 2.205 2.083 2.205h1.334c1.21 0 2.083-1.05 2.083-2.204V5.455c0-1.155-.873-2.205-2.083-2.205zm6.138 7.396a1.75 1.75 0 0 0 0 2.708l8.42 6.89c1.144.935 2.859.122 2.859-1.354V5.11c0-1.476-1.715-2.29-2.858-1.354zm.95 1.547a.25.25 0 0 1 0-.386l8.42-6.89a.25.25 0 0 1 .409.193v13.78a.25.25 0 0 1-.408.193z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPrevious;
